package org.vreo.devicehub.features.liveAccess.presentation

/**
 * Live access actions
 */
sealed interface LiveAccessActions {
    data object OnClearError : LiveAccessActions
    data class OnUpdateConnectionMode(val index: Int) : LiveAccessActions
    data object OnConnectClicked : LiveAccessActions
    data object OnDisconnectClicked : LiveAccessActions
    data class OnEnableClicked(val enable: Boolean) : LiveAccessActions

}